import React from 'react';
import { styled } from '@compiled/react';
import times from 'lodash/times';
import { SkeletonItem } from '@atlaskit/menu';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { borderRadius } from '@atlassian/jira-common-styles/src/main.tsx';
import { TABLE_HEADER_HEIGHT_PX } from '@atlassian/jira-software-deployments-common-table/src/components/table/common/constants';
import {
	DEFAULT_LIST_WIDTH,
	DEFAULT_ITEM_HEIGHT,
} from '@atlassian/jira-software-deployments-common-table/src/model/table';
import { ISSUE_PAGE_SIZE } from '../../../services/core-data/constants.tsx';

const LoadingSkeleton = () => (
	<LoadingSkeletonWrapper data-testId="deployments.table.loading-skeleton">
		<Header />
		{times(ISSUE_PAGE_SIZE, (index) => (
			<Row key={index} isOdd={index % 2 === 1}>
				<SkeletonItem hasIcon isShimmering width={DEFAULT_LIST_WIDTH} />
			</Row>
		))}
	</LoadingSkeletonWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadingSkeletonWrapper = styled.div({
	height: '100%',
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${borderRadius}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `1px solid ${token('color.border', colors.N30)}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Header = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: TABLE_HEADER_HEIGHT_PX,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.skeleton', colors.N20),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `1px solid ${token('color.border', colors.N30)}`,
});

interface RowProps {
	isOdd: boolean;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Row = styled.div<RowProps>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${DEFAULT_ITEM_HEIGHT}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		props.isOdd ? token('color.skeleton.subtle', colors.N0) : token('color.skeleton', colors.N10),
});

export default LoadingSkeleton;
